// extracted by mini-css-extract-plugin
export default {"button":"Button_button__l-B33","disabled":"Button_disabled__YEsDK","outlineButton":"Button_outlineButton__ytsJk","primaryButton":"Button_primaryButton__GH5qL"};